const releasesDE = {
    "view": {
        "table": {
            "title": "Ihre Veröffentlichungen Liste",
            "column": {
                "name": "Name",
                "artist": "Künstler",
                "catalogue_number": "Kat. Nr.",
                "release_date": "Veröffentlichungsdatum",
                "status": "Status",
                "store_urls": "Store-URLs",
                "qc": "QC",
                "pre_scan": "Vorab-Scan",
                "alert": "Warnung",
                "flagged": "Markiert",
                "action": "Aktion"
            },
            "label": {
                "status_ready": "Bereit",
                "status_approval": "Eingereicht",
                "status_takedown_request": "Entfernungsanfrage",
                "status_taken_down": "Entfernt",
                "status_distributed": "Verteilt",
                "status_locked": "In Bearbeitung - Gesperrt",
                "status_delivering": "Lieferung",
                "status_unlocked": "Bitte bearbeiten",
                "status_offline": "Offline",
                "status_re_delivery-delivery": "Neu-Lieferung",
                "status_re_delivery-editing": "Neu-Lieferung Bearbeitung",
                "status_unknown": "Unbekannter Status"
            },
            "button": {
                "export_csv": "CSV exportieren"
            },
            "placeholder": {
                "search": "Suchen..."
            },
            "dropdown": {
                "item": {
                    "action": "Aktion",
                    "distribute": "Verteilen",
                    "viewRelease": "Veröffentlichung ansehen",
                    "editReleaseMetadata": "Veröffentlichungs-Metadaten bearbeiten",
                    "editTracks": "Tracks bearbeiten",
                    "takedown": "Entfernen",
                    "submitEditing": "Bearbeitung einreichen",
                    "deliveredList": "Gelieferte Liste",
                    "copyEanUpc": "EAN/UPC kopieren"
                },
                "message": {
                    "submitInformationTooltip": "Sie haben noch nicht alle Informationen bereitgestellt, daher können Sie die Veröffentlichungen nicht verteilen. Bitte reichen Sie Ihre Informationen ein.",
                    "submitMetadataTooltip": "Bitte reichen Sie die Metadaten für alle Tracks ein, um die Veröffentlichung zu verteilen.",
                    "submitEditingMetadataTooltip": "Bitte reichen Sie die Metadaten für alle Tracks ein, um die Bearbeitungen einzureichen.",
                    "submitEditingTokenRequiredTooltip": "Mindestens 1 Token ist erforderlich, um die Bearbeitung für die Neu-Lieferung einzureichen. <2>Tokens bestellen</2>.",
                    "blacklistedArtistTooltip": "Diese Veröffentlichung kann nicht verteilt werden, da sie mindestens einen Track von einem blacklisted Künstler enthält. Bitte kontaktieren Sie unser Support-Team für weitere Informationen.",
                    "distributionDisabledPreScanInProgress": "Bitte warten Sie, bis der Pre Scan abgeschlossen ist, bevor Sie die Veröffentlichung verteilen.",
                    "distributionDisabledPreScanNotDone": "Bitte führen Sie zuerst den Pre Scan aus, um die Veröffentlichung zu verteilen.",
                    "distributionDisabledPreScanDeclarationNotSubmitted": "Bitte reichen Sie zuerst die Pre Scan-Erklärung ein, um die Veröffentlichung zu verteilen.",
                },
                "modal": {
                    "editMetadata": {
                        "header": "Sind Sie wirklich sicher, dass Sie die Metadaten bearbeiten möchten?",
                        "description": {
                            "point1": "<strong>Dies wird Ihre Metadaten ändern und kann die Veröffentlichung beeinflussen.</strong>",
                            "point2": "Fahren Sie nur fort, wenn Sie sich ganz sicher sind.",
                            "point3": "<strong>BITTE NICHT</strong> Metadaten nur zum Testen und Erkunden bearbeiten."
                        },
                        "button": {
                            "cancel": "Abbrechen",
                            "confirm": "Ich verstehe"
                        }
                    },
                    "distribute": {
                        "header": "Sind Sie sicher, dass alle eingegebenen Informationen gültig sind und diese Veröffentlichung vollständig repräsentieren?",
                        "description": {
                            "point1": "Nach dieser Aktion wird Ihre Veröffentlichung überprüft und wenn die Informationen korrekt sind, wird sie an den offiziellen und exklusiven Vertriebsterminen verteilt.",
                            "point2": "Mit der Bestätigung und Annahme dieses Formulars akzeptieren und befolgen Sie vollständig die <1>Vertriebsbedingungen</1>, <3>Nutzungsbedingungen</3> und <5>Datenschutzrichtlinien</5>.",
                            "point3": "Mit der Bestätigung und Annahme dieses Formulars bestätigen Sie unbestreitbar, dass der eingereichte Inhalt mit zugehörigen Assets, Audiodateien und Metadaten entweder ausschließlich Ihnen gehört oder vollständig an Ihr Label lizenziert ist.",
                            "point4": "Hiermit akzeptieren Sie vollständig, dass Sie allein für irreführende Informationen, unlizenzierte Nutzung, illegale Aktivitäten oder jegliche Art von Streitigkeiten verantwortlich sind.",
                            "flaggedTracksTerms": {
                                "header": "Bedingungen für markierte Tracks",
                                "point1": "Bitte beachten Sie: <strong>'{{releaseName}}'</strong> enthält einen oder mehrere markierte Tracks. Eine Gebühr von <strong>15 €</strong> pro markiertem Track fällt an, um die Veröffentlichung an <strong>Spotify</strong> zu liefern. Da Sie sich entschieden haben, diese Gebühr derzeit nicht zu zahlen, wird die Veröffentlichung nicht an Spotify geliefert. Mit der Bestätigung und Annahme dieses Formulars erkennen Sie diese Bedingungen an und akzeptieren sie.",
                                "point2": "Wenn Sie in Zukunft die Veröffentlichung an <strong>Spotify</strong> liefern lassen möchten, können Sie zum markierten Bereich in der Veröffentlichungstabelle gehen und den Zahlungsaufforderungen folgen."
                            },
                            "artificialStreamingDeclaration": {
                                "header": "Erklärung zu künstlichem Streaming",
                                "point1": "<strong>1.</strong> Ich verstehe vollständig und stimme zu, keine Form von künstlichem Streaming zu betreiben, einschließlich der Verwendung von Bots, Streaming-Farmen oder jeglicher Methode, die DSP-Metriken manipuliert.",
                                "point2": "<strong>2.</strong> Ich werde keine Zahlungen für Playlist-Platzierungen leisten oder anbieten, noch werde ich mit Dritten zusammenarbeiten, die garantierte Platzierungen versprechen — ich verstehe, dass dies als Betrug und Abzocke gilt.",
                                "point3": "<strong>3.</strong> Ich erkenne an, dass solche Handlungen zur sofortigen Beendigung, zum Verlust von Tantiemen, zu rechtlichen Ansprüchen, Vertragsstrafen und Gebühren sowie zur Meldung an DSPs und Behörden führen können.",
                                "point4": "<strong>4.</strong> Ich garantiere auch, alle Künstler oder Kunden, mit denen ich arbeite, über diese Regeln zu informieren und sicherzustellen, dass sie diese einhalten.",
                                "point5": "<strong>5.</strong> Ich verstehe, dass, wenn ich künstliches Streaming betreibe, meine KYC-Daten, einschließlich meines vollständigen Namens, meiner Adresse, meines Personalausweises und anderer persönlicher Informationen, mit den Rechtsabteilungen der DSPs, wie denen von Spotify, Apple Music und anderen, geteilt werden können.",
                                "point6": "<strong>6.</strong> Ich übernehme die volle rechtliche Verantwortung für jegliche Verstöße.",
                                "acknowledgment": "Hiermit erkenne ich die oben genannten Bedingungen für künstliches Streaming an und stimme zu, diese einzuhalten, und ich übernehme die volle rechtliche Verantwortung für jegliche Verstöße."
                            }
                        },
                        "button": {
                            "cancel": "Abbrechen",
                            "confirm": "Bestätigen und Akzeptieren"
                        }
                    },
                    "takedown": {
                        "header": "Sind Sie sicher, dass Sie diese Veröffentlichung aus allen Stores entfernen möchten?",
                        "description": {
                            "point1": "Diese Aktion ist unwiderruflich.",
                            "point2": "Durch das Entfernen dieser Veröffentlichung stimmen Sie den <1>Vertriebsbedingungen</1>, <3>Nutzungsbedingungen</3> und <5>Datenschutzrichtlinien</5> zu."
                        },
                        "button": {
                            "cancel": "Abbrechen",
                            "confirm": "Bestätigen und Akzeptieren"
                        }
                    },
                    "finishEditing": {
                        "header": "Sind Sie sicher, dass alle eingegebenen Informationen gültig sind und diese Veröffentlichung vollständig repräsentieren?",
                        "description": {
                            "point1": "Nach dieser Aktion wird Ihre Veröffentlichung überprüft und wenn die Informationen korrekt sind, wird sie an die DSP-Partner neu verteilt. <strong>HINWEIS: Nur METADATEN werden an DSPs gesendet, Inhalte wie BILDER und AUDIODATEIEN können auf diese Weise nicht aktualisiert werden.</strong>",
                            "point2": "Mit der Bestätigung und Annahme dieses Formulars akzeptieren und befolgen Sie vollständig die <1>Nutzungsbedingungen</1> und die Bedingungen unserer exklusiven Vertriebsvereinbarung.",
                            "point3": "Mit der Bestätigung und Annahme dieses Formulars akzeptieren und befolgen Sie vollständig die <1>Datenschutzrichtlinien</1>.",
                            "point4": "Mit der Bestätigung und Annahme dieses Formulars bestätigen Sie unbestreitbar, dass der eingereichte Inhalt mit zugehörigen Assets, Audiodateien und Metadaten entweder ausschließlich Ihnen gehört oder vollständig an Ihr Label lizenziert ist.",
                            "point5": "Hiermit akzeptieren Sie vollständig, dass Sie allein für irreführende Informationen, unlizenzierte Nutzung, illegale Aktivitäten oder jegliche Art von Streitigkeiten verantwortlich sind."
                        },
                        "button": {
                            "cancel": "Abbrechen",
                            "confirm": "Bestätigen und Akzeptieren"
                        }
                    }
                }
            },
            "message": {
                "success": "Veröffentlichung aktualisiert!",
                "declaration_success": "Erklärung zur Überprüfung durch den Administrator eingereicht.",
                "declaration_error": "Beim Einreichen der Erklärung ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.",
                "pre_scan_declaration_success": "Pre Scan-Erklärung erfolgreich eingereicht.",
                "pre_scan_declaration_error": "Beim Einreichen der Pre Scan-Erklärung ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.",
                "pre_scan_success": "Veröffentlichung erfolgreich für Scan eingereicht.",
                "pre_scan_error": "Beim Scannen der Veröffentlichung ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.",
                "linkCopied": "Link in die Zwischenablage kopiert!"
            }
        },
        "message": {
            "trackDistributionAllowanceSpent": "Sie haben Ihre Track-Verteilungszulage aufgebraucht. Um weitere Tracks hochzuladen, aktualisieren Sie bitte Ihr Konto oder kontaktieren Sie unser Support-Team.",
            "subscriptionUpgrade": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>setzen</1> Sie Ihr Abonnement fort, um diese Funktion zu nutzen.",
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen.",
            "subscriptionUpgradeReleaseTransfer": "Ihr aktueller Abonnementplan unterstützt die Funktion zur Veröffentlichungstransfer nicht. Wenn Sie einen größeren Back-Katalog übertragen oder mehr Plattenlabel-Kataloge mit nur wenigen Klicks zu Music Link übertragen möchten, <1>aktualisieren</1> Sie bitte Ihren Abonnementplan.",
            "noAccessReleaseTransfer": "Derzeit haben Sie keine Berechtigung zur Nutzung der Veröffentlichungstransferfunktion. Wenn Sie einen größeren Back-Katalog übertragen oder mehr Plattenlabel-Kataloge mit nur wenigen Klicks zu Music Link übertragen möchten, zögern Sie nicht, unser Support-Team zu kontaktieren.",
            "accountBlacklisted": "Ihr Konto wurde blacklisted nach Überprüfung, da wir festgestellt haben, dass die Informationen, die mit Ihrem Konto verknüpft sind, mit einem internationalen blacklisted Benutzer in unserem System verknüpft sind. Aus diesem Grund haben wir die Verteilungsfunktion für Ihr Konto deaktiviert.",
        }
    },
    "add": {
        "title": "Neue Veröffentlichung hinzufügen",
        "form": {
            "label": {
                "required": "Erforderlich",
                "name": "Veröffentlichungsname",
                "version": "Veröffentlichungsversion",
                "subuser": "Unterbenutzer",
                "label": "Label",
                "copyright": "Copyright ©",
                "copyright_year": "Copyright © Jahr",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Copyright ℗ Jahr",
                "genre": "Genre",
                "subgenre": "Sub-Genre",
                "catalog_number": "Katalognummer",
                "artwork": "Artwork",
                "artwork_alt": "Ihr Artwork",
                "new_release": "Ist dies eine neue Veröffentlichung?",
                "original_release_date": "Ursprüngliches Veröffentlichungsdatum",
                "official_release_date": "Offizielles Veröffentlichungsdatum",
                "backcatalog": "Backkatalog",
                "assisted_dates": "Unterstützte Daten",
                "exclusive_store_release_date": "Exklusives Store-Veröffentlichungsdatum",
                "additional_metadata": "Zusätzliche Metadaten",
                "release_description": "Veröffentlichungsbeschreibung",
                "release_language": "Sprache des Veröffentlichungsnamens",
                "auto_detect_language": "Automatisch erkennen (Sprache)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Automatisch generieren (ean)",
                "territories": "Gebiete",
                "countries": "Länder",
                "youtube_declaration_header": "YOUTUBE CONTENT ID ERKLÄRUNG",
                "youtube_declaration_intro": "Um sich für YouTube Content ID für diese Veröffentlichung anzumelden, müssen Sie sicherstellen, dass Sie ALLE folgenden Anforderungen erfüllen:",
                "youtube_declaration_certify": "Ich, <strong>{{firstName}} {{lastName}}</strong>, erkläre unter Strafe des Meineids, dass die vorstehenden Informationen wahr und korrekt sind.",
                "youtube_declaration_point1": "Ich habe ausreichende Rechte an dem Material.",
                "youtube_declaration_point2": "Alle Referenzinhalte sind ausreichend unterscheidbar.",
                "youtube_declaration_point3": "Ich habe individuelle Referenzen für jedes Stück geistigen Eigentums.",
                "youtube_declaration_point4": "Gelieferte Inhalte sind <strong>nicht</strong> eines der folgenden: gemeinfreie, nicht exklusiv lizenzierte Inhalte, Clips aus anderen Quellen, die unter Fair-Use-Prinzipien verwendet werden, Videospielaufnahmen (außer vom Publisher des Spiels), Karaoke-Aufnahmen, Remaster ohne Erlaubnis, Sound-alike-Aufnahmen, synchronisierte Inhalte, Beschleunigung/Verlangsamung, Soundeffekte, Soundbeds, kontinuierliche DJ-Mixes, Mashups, Countdown-Listen oder andere verbotene oder nicht zulässige Inhalte, die in den unten aufgeführten YouTube Content ID-Richtlinien genannt werden.",
                "youtube_declaration_account": "Ich verstehe, dass mein Konto bei Verstößen deaktiviert und gekündigt werden kann. Darüber hinaus verstehe ich vollständig, dass ich für alle Gebühren, Schäden, Rechtskosten oder andere anfallende Kosten haftbar gemacht werden kann.",
                "youtube_declaration_guidelines": "Gemäß <1><strong>YouTubes Content ID-Richtlinien</strong></1> ist der durch diese Veröffentlichung eingereichte Inhalt vollständig für YouTube Content ID berechtigt.",
                "youtube_content_id_eligible": "Ich bestätige, dass mein Inhalt für <strong>YouTube Content ID</strong> berechtigt ist",
                "youtube_content_id_not_eligible": "Mein Inhalt ist nicht für <strong>YouTube Content ID</strong> berechtigt",
                "immersive_audio": "Diese Veröffentlichung hat Immersive Audio"
            },
            "placeholder": {
                "version": "Leer lassen, wenn Sie sich nicht sicher sind oder wenn dies eine reguläre Veröffentlichung ist",
                "select_date": "Datum auswählen...",
                "copyright": "Normalerweise Ihr Labelname",
                "copyright_publisher": "Normalerweise Ihr Labelname",
                "copyright_year": "JJJJ",
                "copyright_year_publisher": "JJJJ",
                "catalog_number": "Geben Sie Ihre Katalognummer ein. Normalerweise fügen Labels eine Abkürzung des Labelnamens und eine Nummer ein. Z.B. {{prefix}}001, {{prefix}}002...",
                "label": "Label auswählen...",
                "subuser": "Unterbenutzer auswählen...",
                "genre": "Genre auswählen...",
                "subgenre": "Sub-Genre auswählen...",
                "ean": "Leer lassen, wenn Sie sich nicht sicher sind!",
                "release_description": "Ein paar Worte über Ihre Veröffentlichung. Bitte keine Links und E-Mail-Adressen. Maximal 600 Zeichen"
            },
            "help_text": {
                "name": "Bitte verwenden Sie keine Veröffentlichungsnamen-Zusätze wie LP und EP.",
                "version": "Einige Veröffentlichungen werden in mehr als einer Version veröffentlicht, wenn ja, geben Sie bitte den Versionsnamen ein. Wenn Ihre Veröffentlichung eine Original-/Standardveröffentlichung ist, ignorieren Sie dieses Feld bitte.",
                "subuser": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung für einen Ihrer Unterbenutzer hinzufügen möchten, andernfalls lassen Sie es unselektiert.",
                "label": "Hinweis: Bitte wählen Sie Ihr Label aus dem Dropdown-Menü aus, wenn es bereits im System existiert, andernfalls erstellen Sie Ihr Label, indem Sie <1>hier</1> klicken, sobald es erstellt ist, können Sie es dann aus dem Dropdown-Menü auswählen.",
                "catalog_number": "Geben Sie Ihre Katalognummer ein. Normalerweise fügen Labels eine Abkürzung des Labelnamens und eine Nummer ein. Z.B. {{prefix}}001, {{prefix}}002...",
                "artwork": "Laden Sie JPG-Formate hoch, Auflösung nur 3000x3000 px, @ 72 dpi",
                "original_release_date": "Ursprüngliches Veröffentlichungsdatum für alle Shops weltweit.",
                "official_release_date": "Offizielles Veröffentlichungsdatum für alle Shops weltweit.",
                "release_language": "In welcher Sprache ist der Veröffentlichungsname geschrieben? Bitte überprüfen Sie es doppelt, wenn Sie sich nicht sicher sind. Wenn diese Eingabe falsch ist, werden einige Stores wie iTunes und Apple Music die Veröffentlichung ablehnen.",
                "ean": "Der Universal Product Code oder die Europäische Artikelnummer für die Veröffentlichung. Gültige Codes sind 13-stellig. Wenn Sie keinen eigenen haben, werden wir einen für Sie generieren."
            },
            "option": {
                "yes": "Ja",
                "no": "Nein",
                "no_exclusive": "Keine Exklusivität",
                "beatport_2weeks": "Beatport 2 Wochen",
                "beatport_4weeks": "Beatport 4 Wochen",
                "preorder_1week": "Vorbestellung 1 Woche",
                "preorder_2weeks": "Vorbestellung 2 Wochen",
                "traxsource_2weeks": "Traxsource 2 Wochen",
                "select": "Auswählen...",
                "worldwide": "Weltweit",
                "only_selected": "Nur ausgewählte Länder",
                "all_except_selected": "Alle außer ausgewählte Länder"
            },
            "message": {
                "track_name_required": "Bitte geben Sie den Tracknamen ein",
                "mix_name_required": "Bitte geben Sie den Mixnamen ein",
                "mix_name_invalid": "Der Mixname darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen",
                "artist_required": "Bitte wählen Sie einen Künstler aus",
                "artist_type_required": "Bitte wählen Sie den Künstler-Typ aus",
                "catalog_duplicate": "Katalognummer '{{number}}' wurde verwendet. Bitte geben Sie eine andere ein.",
                "ean_duplicate": "Diese EAN-Nummer ist mit einer anderen Veröffentlichung verknüpft. Bitte geben Sie eine andere ein.",
                "artist_added": "Neuer Künstler wurde hinzugefügt!",
                "track_limit": "Ihr aktuelles Track-Limit ist unzureichend. Bitte aktualisieren Sie Ihr Konto oder kontaktieren Sie den Support.",
                "select_day": "Bitte wählen Sie einen Tag aus.",
                "form_error": "Formular kann nicht eingereicht werden! Bitte füllen Sie alle Felder aus und überprüfen Sie die Fehler!",
                "ean_invalid": "Der Wert ist keine gültige EAN. Wenn Sie eine neue Veröffentlichung einfügen, lassen Sie dieses Feld leer und wir generieren eine EAN für Sie. Wenn Sie einen Back-Katalog hochladen und die EAN ungültig ist, kontaktieren Sie uns bitte.",
                "ean_length": "Die EAN-Nummer muss 13 Zeichen lang sein",
                "artwork_invalid": "Diese Datei ist ungültig, bitte stellen Sie sicher, dass das Bild die .jpg-Erweiterung hat, RGB-Farben, 3000 x 3000 Abmessungen und bis zu 4 MB.",
                "track_invalid": "Diese Datei ist ungültig, bitte stellen Sie sicher, dass Ihre Datei ordnungsgemäß in 16 Bit, 44,1 kHz codiert ist.",
                "artworkSwapTokenRequiredTooltip": "Ihr aktuelles Token-Guthaben ist unzureichend. Es ist mindestens 1 Token erforderlich, um das Cover-Artwork auszutauschen."
            },
            "button": {
                "reset": "Zurücksetzen",
                "save_only": "Nur speichern",
                "save_and_continue": "Speichern und fortfahren"
            },
            "modal": {
                "assisted_days": {
                    "header": "Sind Sie sicher, dass Sie die besten Praktiken für das Veröffentlichungsdatum ignorieren möchten?",
                    "body": "Bitte beachten Sie, dass durch die Auswahl dieser Option Ihr Veröffentlichungsdatum möglicherweise nicht von den Stores akzeptiert oder am ausgewählten Datum aufgenommen und veröffentlicht wird. Darüber hinaus reduzieren Sie die Marketingmöglichkeiten erheblich.",
                    "button": {
                        "cancel": "Abbrechen",
                        "confirm": "Bestätigen"
                    }
                },
                "release_created": {
                    "header": "Veröffentlichung erstellt!",
                    "body": "Ihre Veröffentlichung wurde erfolgreich erstellt!",
                    "button": {
                        "close": "Schließen"
                    }
                }
            }
        }
    },
    "update": {
        "title": "Veröffentlichung aktualisieren",
        "form": {
            "label": {
                "required": "Erforderlich",
                "name": "Veröffentlichungsname",
                "version": "Veröffentlichungsversion",
                "subuser": "Unterbenutzer",
                "label": "Label",
                "copyright": "Copyright ©",
                "copyright_year": "Copyright © Jahr",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Copyright ℗ Jahr",
                "genre": "Genre",
                "subgenre": "Sub-Genre",
                "catalog_number": "Katalognummer",
                "artwork": "Artwork",
                "artwork_alt": "Ihr Artwork",
                "new_release": "Ist dies eine neue Veröffentlichung?",
                "original_release_date": "Ursprüngliches Veröffentlichungsdatum",
                "official_release_date": "Offizielles Veröffentlichungsdatum",
                "backcatalog": "Backkatalog",
                "assisted_dates": "Unterstützte Daten",
                "exclusive_store_release_date": "Exklusives Store-Veröffentlichungsdatum",
                "additional_metadata": "Zusätzliche Metadaten",
                "release_description": "Veröffentlichungsbeschreibung",
                "release_language": "Sprache des Veröffentlichungsnamens",
                "auto_detect_language": "Automatisch erkennen (Sprache)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Automatisch generieren (ean)",
                "territories": "Gebiete",
                "countries": "Länder",
                "youtube_declaration_header": "YOUTUBE CONTENT ID ERKLÄRUNG",
                "youtube_declaration_intro": "Um sich für YouTube Content ID für diese Veröffentlichung anzumelden, müssen Sie sicherstellen, dass Sie ALLE folgenden Anforderungen erfüllen:",
                "youtube_declaration_certify": "Ich, <strong>{{firstName}} {{lastName}}</strong>, erkläre unter Strafe des Meineids, dass die vorstehenden Informationen wahr und korrekt sind.",
                "youtube_declaration_point1": "Ich habe ausreichende Rechte an dem Material.",
                "youtube_declaration_point2": "Alle Referenzinhalte sind ausreichend unterscheidbar.",
                "youtube_declaration_point3": "Ich habe individuelle Referenzen für jedes Stück geistigen Eigentums.",
                "youtube_declaration_point4": "Gelieferte Inhalte sind <strong>nicht</strong> eines der folgenden: gemeinfreie, nicht exklusiv lizenzierte Inhalte, Clips aus anderen Quellen, die unter Fair-Use-Prinzipien verwendet werden, Videospielaufnahmen (außer vom Publisher des Spiels), Karaoke-Aufnahmen, Remaster ohne Erlaubnis, Sound-alike-Aufnahmen, synchronisierte Inhalte, Beschleunigung/Verlangsamung, Soundeffekte, Soundbeds, kontinuierliche DJ-Mixes, Mashups, Countdown-Listen oder andere verbotene oder nicht zulässige Inhalte, die in den unten aufgeführten YouTube Content ID-Richtlinien genannt werden.",
                "youtube_declaration_account": "Ich verstehe, dass mein Konto bei Verstößen deaktiviert und gekündigt werden kann. Darüber hinaus verstehe ich vollständig, dass ich für alle Gebühren, Schäden, Rechtskosten oder andere anfallende Kosten haftbar gemacht werden kann.",
                "youtube_declaration_guidelines": "Gemäß <1><strong>YouTubes Content ID-Richtlinien</strong></1> ist der durch diese Veröffentlichung eingereichte Inhalt vollständig für YouTube Content ID berechtigt.",
                "youtube_content_id_eligible": "Ich bestätige, dass mein Inhalt für <strong>YouTube Content ID</strong> berechtigt ist",
                "youtube_content_id_not_eligible": "Mein Inhalt ist nicht für <strong>YouTube Content ID</strong> berechtigt",
                "immersive_audio": "Diese Veröffentlichung hat Immersive Audio"
            },
            "placeholder": {
                "version": "Leer lassen, wenn Sie sich nicht sicher sind oder wenn dies eine reguläre Veröffentlichung ist",
                "select_date": "Datum auswählen...",
                "copyright": "Normalerweise Ihr Labelname",
                "copyright_publisher": "Normalerweise Ihr Labelname",
                "copyright_year": "JJJJ",
                "copyright_year_publisher": "JJJJ",
                "catalog_number": "Geben Sie Ihre Katalognummer ein. Normalerweise fügen Labels eine Abkürzung des Labelnamens und eine Nummer ein. Z.B. {{prefix}}001, {{prefix}}002...",
                "label": "Label auswählen...",
                "subuser": "Unterbenutzer auswählen...",
                "genre": "Genre auswählen...",
                "subgenre": "Sub-Genre auswählen...",
                "ean": "Leer lassen, wenn Sie sich nicht sicher sind!",
                "release_description": "Ein paar Worte über Ihre Veröffentlichung. Bitte keine Links und E-Mail-Adressen. Maximal 600 Zeichen"
            },
            "help_text": {
                "name": "Bitte verwenden Sie keine Veröffentlichungsnamen-Zusätze wie LP und EP.",
                "version": "Einige Veröffentlichungen werden in mehr als einer Version veröffentlicht, wenn ja, geben Sie bitte den Versionsnamen ein. Wenn Ihre Veröffentlichung eine Original-/Standardveröffentlichung ist, ignorieren Sie dieses Feld bitte.",
                "subuser": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung für einen Ihrer Unterbenutzer hinzufügen möchten, andernfalls lassen Sie es unselektiert.",
                "label": "Hinweis: Bitte wählen Sie Ihr Label aus dem Dropdown-Menü aus, wenn es bereits im System existiert, andernfalls erstellen Sie Ihr Label, indem Sie <1>hier</1> klicken, sobald es erstellt ist, können Sie es dann aus dem Dropdown-Menü auswählen.",
                "catalog_number": "Geben Sie Ihre Katalognummer ein. Normalerweise fügen Labels eine Abkürzung des Labelnamens und eine Nummer ein. Z.B. {{prefix}}001, {{prefix}}002...",
                "artwork": "Laden Sie JPG-Formate hoch, Auflösung nur 3000x3000 px, @ 72 dpi",
                "original_release_date": "Ursprüngliches Veröffentlichungsdatum für alle Shops weltweit.",
                "official_release_date": "Offizielles Veröffentlichungsdatum für alle Shops weltweit.",
                "release_language": "In welcher Sprache ist der Veröffentlichungsname geschrieben? Bitte überprüfen Sie es doppelt, wenn Sie sich nicht sicher sind. Wenn diese Eingabe falsch ist, werden einige Stores wie iTunes und Apple Music die Veröffentlichung ablehnen.",
                "ean": "Der Universal Product Code oder die Europäische Artikelnummer für die Veröffentlichung. Gültige Codes sind 13-stellig. Wenn Sie keinen eigenen haben, werden wir einen für Sie generieren."
            },
            "option": {
                "yes": "Ja",
                "no": "Nein",
                "no_exclusive": "Keine Exklusivität",
                "beatport_2weeks": "Beatport 2 Wochen",
                "beatport_4weeks": "Beatport 4 Wochen",
                "preorder_1week": "Vorbestellung 1 Woche",
                "preorder_2weeks": "Vorbestellung 2 Wochen",
                "traxsource_2weeks": "Traxsource 2 Wochen",
                "select": "Auswählen...",
                "worldwide": "Weltweit",
                "only_selected": "Nur ausgewählte Länder",
                "all_except_selected": "Alle außer ausgewählte Länder"
            },
            "message": {
                "track_name_required": "Bitte geben Sie den Tracknamen ein",
                "mix_name_required": "Bitte geben Sie den Mixnamen ein",
                "mix_name_invalid": "Der Mixname darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen",
                "artist_required": "Bitte wählen Sie einen Künstler aus",
                "artist_type_required": "Bitte wählen Sie den Künstler-Typ aus",
                "catalog_duplicate": "Katalognummer '{{number}}' wurde verwendet. Bitte geben Sie eine andere ein.",
                "ean_duplicate": "Diese EAN-Nummer ist mit einer anderen Veröffentlichung verknüpft. Bitte geben Sie eine andere ein.",
                "artist_added": "Neuer Künstler wurde hinzugefügt!",
                "track_limit": "Ihr aktuelles Track-Limit ist {{trackLimit}} Track(s). Um weitere Tracks hochzuladen, aktualisieren Sie bitte Ihr Konto oder kontaktieren Sie unser Support-Team.",
                "select_day": "Bitte wählen Sie einen Tag aus.",
                "form_error": "Formular kann nicht eingereicht werden! Bitte füllen Sie alle Felder aus und überprüfen Sie die Fehler!",
                "ean_invalid": "Der Wert ist keine gültige EAN. Wenn Sie eine neue Veröffentlichung einfügen, lassen Sie dieses Feld leer und wir generieren eine EAN für Sie. Wenn Sie einen Back-Katalog hochladen und die EAN ungültig ist, kontaktieren Sie uns bitte.",
                "ean_length": "Die EAN-Nummer muss 13 Zeichen lang sein",
                "artwork_invalid": "Diese Datei ist ungültig, bitte stellen Sie sicher, dass das Bild die .jpg-Erweiterung hat, RGB-Farben, 3000 x 3000 Abmessungen und bis zu 4 MB.",
                "track_invalid": "Diese Datei ist ungültig, bitte stellen Sie sicher, dass Ihre Datei ordnungsgemäß in 16 Bit, 44,1 kHz codiert ist."
            },
            "button": {
                "reset": "Zurücksetzen",
                "submit_form": "Formular einreichen",
                "save_and_continue": "Speichern und fortfahren"
            },
            "modal": {
                "assisted_days": {
                    "header": "Sind Sie sicher, dass Sie die besten Praktiken für das Veröffentlichungsdatum ignorieren möchten?",
                    "body": "Bitte beachten Sie, dass durch die Auswahl dieser Option Ihr Veröffentlichungsdatum möglicherweise nicht von den Stores akzeptiert oder am ausgewählten Datum aufgenommen und veröffentlicht wird. Darüber hinaus reduzieren Sie die Marketingmöglichkeiten erheblich.",
                    "button": {
                        "cancel": "Abbrechen",
                        "confirm": "Bestätigen"
                    }
                },
                "release_updated": {
                    "header": "Veröffentlichung aktualisiert!",
                    "body": "Ihre Veröffentlichung wurde erfolgreich aktualisiert!",
                    "button": {
                        "close": "Schließen"
                    }
                }
            }
        }
    },
    "transfer": {
        "title": "Veröffentlichung übertragen",
        "view": {
            "title": "Veröffentlichung übertragen",
            "label": {
                "searchBy": "Suchen nach",
                "upc": "UPC-Nummer",
                "url": "Store-Veröffentlichungs-URL",
                "name": "Veröffentlichungsname",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "fetchReleaseDetails": "Veröffentlichungsdetails abrufen..."
            },
            "placeholder": {
                "upc": "Geben Sie die UPC/EAN-Nummer der Veröffentlichung ein, z.B. 5055964352523",
                "url": "Geben Sie die Store-URL der Veröffentlichung ein, z.B. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn oder www.deezer.com/en/album/413370367",
                "name": "Geben Sie den Veröffentlichungsnamen ein, z.B. Warrior"
            },
            "help_text": {
                "upc": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung hinzufügen möchten, die bereits auf Spotify oder Deezer ist.",
                "url": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung hinzufügen möchten, die bereits auf Spotify oder Deezer ist.",
                "name_spotify": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung hinzufügen möchten, die bereits auf Spotify ist.",
                "name_deezer": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung hinzufügen möchten, die bereits auf Deezer ist."
            },
            "button": {
                "reset": "Zurücksetzen",
                "transfer": "Übertragen"
            },
            "message": {
                "release_exists": "Eine Veröffentlichung mit dieser UPC-Nummer gehört bereits einem anderen Benutzer innerhalb einer Music Link-Plattform. Bitte importieren Sie nur Veröffentlichungen, die vollständig Ihrem Unternehmen und Label gehören. Wenn Sie glauben, dass jemand Ihre Veröffentlichung ohne Erlaubnis genommen hat, wenden Sie sich bitte an unser Support-Team."
            }
        },
        "modal": {
            "header": "Bedingungen für die Veröffentlichungstransfer",
            "ownership_warranty": {
                "header": "Eigentumsgarantie",
                "body": {
                    "point1": "Mit der Annahme dieser Bedingungen erkennen Sie an und garantieren, dass Sie das rechtmäßige Eigentum oder die rechtmäßige Vertretung des rechtmäßigen Eigentümers aller hier bereitgestellten Inhalte, einschließlich der Veröffentlichung und der zugehörigen Songs, haben.",
                    "point2": "Sie versichern, dass in dieser Veröffentlichung kein urheberrechtlich geschütztes Material oder geistiges Eigentum Dritter enthalten ist."
                }
            },
            "non_infringement_warranty": {
                "header": "Garantie der Nichtverletzung",
                "body": {
                    "point1": "Durch das Fortfahren bestätigen Sie ausdrücklich, dass die in dieser Veröffentlichung eingereichten Inhalte keine Rechte Dritter verletzen, einschließlich, aber nicht beschränkt auf Urheberrechte, Markenrechte oder andere Eigentumsrechte.",
                    "point2": "Sie stimmen zu, kein Material aus externen Quellen ohne ordnungsgemäße Genehmigung einzubeziehen."
                }
            },
            "exclusivity_declaration": {
                "header": "Exklusivitätserklärung",
                "body": {
                    "point1": "Mit der Zustimmung zu diesen Bedingungen verpflichten Sie sich, dass die in dieser Veröffentlichung präsentierten Inhalte exklusiv Ihrem Eigentum oder Ihrer autorisierten Vertretung gehören und nicht an eine andere Entität oder Plattform angeboten oder veröffentlicht wurden.",
                    "point2": "Sie übernehmen die volle Verantwortung für jegliche Verletzung der Exklusivität und verstehen, dass eine solche Verletzung zu rechtlichen Konsequenzen führen kann."
                }
            },
            "legal_consequences_awareness": {
                "header": "Bewusstsein für rechtliche Konsequenzen",
                "body": {
                    "point1": "Es ist wichtig zu verstehen, dass ein Verstoß gegen die in diesem Modal oder den Bedingungen festgelegten Bedingungen und Garantien zu schwerwiegenden rechtlichen Konsequenzen führen kann.",
                    "point2": "Diese Strafen könnten, ohne darauf beschränkt zu sein, erhebliche finanzielle Verpflichtungen, rechtliche Unterlassungen und Rufschädigung umfassen.",
                    "point3": "Mit der Annahme dieser Bedingungen erkennen Sie die Ernsthaftigkeit der Einhaltung der angegebenen Verpflichtungen an und erkennen an, dass die Nichteinhaltung rechtliche Schritte gegen Sie oder Ihre Organisation nach sich ziehen kann."
                }
            },
            "button": {
                "cancel": "Abbrechen",
                "agree": "Ich stimme zu"
            }
        },
        "form": {
            "title": "Veröffentlichung übertragen",
            "label": {
                "required": "Erforderlich",
                "name": "Veröffentlichungsname",
                "version": "Veröffentlichungsversion",
                "subuser": "Unterbenutzer",
                "label": "Label",
                "copyright": "Copyright ©",
                "copyright_year": "Copyright © Jahr",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Copyright ℗ Jahr",
                "genre": "Genre",
                "subgenre": "Sub-Genre",
                "catalog_number": "Katalognummer",
                "artwork": "Artwork",
                "artwork_alt": "Ihr Artwork",
                "new_release": "Ist dies eine neue Veröffentlichung?",
                "original_release_date": "Ursprüngliches Veröffentlichungsdatum",
                "official_release_date": "Offizielles Veröffentlichungsdatum",
                "backcatalog": "Backkatalog",
                "assisted_dates": "Unterstützte Daten",
                "exclusive_store_release_date": "Exklusives Store-Veröffentlichungsdatum",
                "additional_metadata": "Zusätzliche Metadaten",
                "release_description": "Veröffentlichungsbeschreibung",
                "release_language": "Sprache des Veröffentlichungsnamens",
                "auto_detect_language": "Automatisch erkennen (Sprache)",
                "ean": "EAN / UPC",
                "territories": "Gebiete",
                "countries": "Länder",
                "youtube_declaration_header": "YOUTUBE CONTENT ID ERKLÄRUNG",
                "youtube_declaration_intro": "Um sich für YouTube Content ID für diese Veröffentlichung anzumelden, müssen Sie sicherstellen, dass Sie ALLE folgenden Anforderungen erfüllen:",
                "youtube_declaration_certify": "Ich, <strong>{{firstName}} {{lastName}}</strong>, erkläre unter Strafe des Meineids, dass die vorstehenden Informationen wahr und korrekt sind.",
                "youtube_declaration_point1": "Ich habe ausreichende Rechte an dem Material.",
                "youtube_declaration_point2": "Alle Referenzinhalte sind ausreichend unterscheidbar.",
                "youtube_declaration_point3": "Ich habe individuelle Referenzen für jedes Stück geistigen Eigentums.",
                "youtube_declaration_point4": "Gelieferte Inhalte sind <strong>nicht</strong> eines der folgenden: gemeinfreie, nicht exklusiv lizenzierte Inhalte, Clips aus anderen Quellen, die unter Fair-Use-Prinzipien verwendet werden, Videospielaufnahmen (außer vom Publisher des Spiels), Karaoke-Aufnahmen, Remaster ohne Erlaubnis, Sound-alike-Aufnahmen, synchronisierte Inhalte, Beschleunigung/Verlangsamung, Soundeffekte, Soundbeds, kontinuierliche DJ-Mixes, Mashups, Countdown-Listen oder andere verbotene oder nicht zulässige Inhalte, die in den unten aufgeführten YouTube Content ID-Richtlinien genannt werden.",
                "youtube_declaration_account": "Ich verstehe, dass mein Konto bei Verstößen deaktiviert und gekündigt werden kann. Darüber hinaus verstehe ich vollständig, dass ich für alle Gebühren, Schäden, Rechtskosten oder andere anfallende Kosten haftbar gemacht werden kann.",
                "youtube_declaration_guidelines": "Gemäß <1><strong>YouTubes Content ID-Richtlinien</strong></1> ist der durch diese Veröffentlichung eingereichte Inhalt vollständig für YouTube Content ID berechtigt.",
                "youtube_content_id_eligible": "Ich bestätige, dass mein Inhalt für <strong>YouTube Content ID</strong> berechtigt ist",
                "youtube_content_id_not_eligible": "Mein Inhalt ist nicht für <strong>YouTube Content ID</strong> berechtigt",
                "immersive_audio": "Diese Veröffentlichung hat Immersive Audio"
            },
            "placeholder": {
                "version": "Leer lassen, wenn Sie sich nicht sicher sind oder wenn dies eine reguläre Veröffentlichung ist",
                "select_date": "Datum auswählen...",
                "copyright": "Normalerweise Ihr Labelname",
                "copyright_publisher": "Normalerweise Ihr Labelname",
                "copyright_year": "JJJJ",
                "copyright_year_publisher": "JJJJ",
                "catalog_number": "Geben Sie Ihre Katalognummer ein. Normalerweise fügen Labels eine Abkürzung des Labelnamens und eine Nummer ein. Z.B. {{prefix}}001, {{prefix}}002...",
                "label": "Label auswählen...",
                "subuser": "Unterbenutzer auswählen...",
                "genre": "Genre auswählen...",
                "subgenre": "Sub-Genre auswählen...",
                "ean": "Leer lassen, wenn Sie sich nicht sicher sind!",
                "release_description": "Ein paar Worte über Ihre Veröffentlichung. Bitte keine Links und E-Mail-Adressen. Maximal 600 Zeichen"
            },
            "help_text": {
                "name": "Bitte verwenden Sie keine Veröffentlichungsnamen-Zusätze wie LP und EP.",
                "version": "Einige Veröffentlichungen werden in mehr als einer Version veröffentlicht, wenn ja, geben Sie bitte den Versionsnamen ein. Wenn Ihre Veröffentlichung eine Original-/Standardveröffentlichung ist, ignorieren Sie dieses Feld bitte.",
                "subuser": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung für einen Ihrer Unterbenutzer hinzufügen möchten, andernfalls lassen Sie es unselektiert.",
                "label": "Hinweis: Bitte wählen Sie Ihr Label <strong>{{labelName}}</strong> aus dem Dropdown-Menü aus, wenn es bereits im System existiert, andernfalls erstellen Sie Ihr Label <strong>{{labelName}}</strong>, indem Sie <5>hier</5> klicken, sobald es erstellt ist, können Sie es dann aus dem Dropdown-Menü auswählen.",
                "catalog_number": "Geben Sie Ihre Katalognummer ein. Normalerweise fügen Labels eine Abkürzung des Labelnamens und eine Nummer ein. Z.B. {{prefix}}001, {{prefix}}002...",
                "artwork": "Laden Sie JPG-Formate hoch, Auflösung nur 3000x3000 px, @ 72 dpi",
                "original_release_date": "Ursprüngliches Veröffentlichungsdatum für alle Shops weltweit.",
                "official_release_date": "Offizielles Veröffentlichungsdatum für alle Shops weltweit.",
                "release_language": "In welcher Sprache ist der Veröffentlichungsname geschrieben? Bitte überprüfen Sie es doppelt, wenn Sie sich nicht sicher sind. Wenn diese Eingabe falsch ist, werden einige Stores wie iTunes und Apple Music die Veröffentlichung ablehnen.",
                "ean": "Der Universal Product Code oder die Europäische Artikelnummer für die Veröffentlichung. Gültige Codes sind 13-stellig. Wenn Sie keinen eigenen haben, werden wir einen für Sie generieren."
            },
            "option": {
                "yes": "Ja",
                "no": "Nein",
                "no_exclusive": "Keine Exklusivität",
                "beatport_2weeks": "Beatport 2 Wochen",
                "beatport_4weeks": "Beatport 4 Wochen",
                "preorder_1week": "Vorbestellung 1 Woche",
                "preorder_2weeks": "Vorbestellung 2 Wochen",
                "traxsource_2weeks": "Traxsource 2 Wochen",
                "select": "Auswählen...",
                "worldwide": "Weltweit",
                "only_selected": "Nur ausgewählte Länder",
                "all_except_selected": "Alle außer ausgewählte Länder"
            },
            "message": {
                "track_name_required": "Bitte geben Sie den Tracknamen ein",
                "mix_name_required": "Bitte geben Sie den Mixnamen ein",
                "mix_name_invalid": "Der Mixname darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen",
                "artist_required": "Bitte wählen Sie einen Künstler aus",
                "artist_type_required": "Bitte wählen Sie den Künstler-Typ aus",
                "catalog_duplicate": "Katalognummer '{{number}}' wurde verwendet. Bitte geben Sie eine andere ein.",
                "artist_added": "Neuer Künstler wurde hinzugefügt!",
                "track_limit": "Ihr aktuelles Track-Limit ist {{trackLimit}} Track(s). Um weitere Tracks hochzuladen, aktualisieren Sie bitte Ihr Konto oder kontaktieren Sie unser Support-Team.",
                "select_day": "Bitte wählen Sie einen Tag aus.",
                "form_error": "Formular kann nicht eingereicht werden! Bitte füllen Sie alle Felder aus und überprüfen Sie die Fehler!",
                "ean_invalid": "Der Wert ist keine gültige EAN. Wenn Sie eine neue Veröffentlichung einfügen, lassen Sie dieses Feld leer und wir generieren eine EAN für Sie. Wenn Sie einen Back-Katalog hochladen und die EAN ungültig ist, kontaktieren Sie uns bitte.",
                "ean_length": "Die EAN-Nummer muss 13 Zeichen lang sein",
                "artwork_invalid": "Diese Datei ist ungültig, bitte stellen Sie sicher, dass das Bild die .jpg-Erweiterung hat, RGB-Farben, 3000 x 3000 Abmessungen und bis zu 4 MB.",
                "track_invalid": "Diese Datei ist ungültig, bitte stellen Sie sicher, dass Ihre Datei ordnungsgemäß in 16 Bit, 44,1 kHz codiert ist."
            },
            "button": {
                "reset": "Zurücksetzen",
                "save_only": "Nur speichern",
                "save_and_continue": "Speichern und fortfahren"
            },
            "modal": {
                "assisted_days": {
                    "header": "Sind Sie sicher, dass Sie die besten Praktiken für das Veröffentlichungsdatum ignorieren möchten?",
                    "body": "Bitte beachten Sie, dass durch die Auswahl dieser Option Ihr Veröffentlichungsdatum möglicherweise nicht von den Stores akzeptiert oder am ausgewählten Datum aufgenommen und veröffentlicht wird. Darüber hinaus reduzieren Sie die Marketingmöglichkeiten erheblich.",
                    "button": {
                        "cancel": "Abbrechen",
                        "confirm": "Bestätigen"
                    }
                },
                "release_created": {
                    "header": "Veröffentlichung erstellt!",
                    "body": "Ihre Veröffentlichung wurde erfolgreich erstellt!",
                    "button": {
                        "close": "Schließen"
                    }
                },
                "release_transfer_declaration": {
                    "header": "Erklärung zur Veröffentlichungstransfer",
                    "body": "Ich habe alle erforderlichen Informationen für diese Veröffentlichung überprüft und ausgefüllt, und sie ist jetzt bereit für den UPLOAD.",
                    "button": {
                        "cancel": "Abbrechen",
                        "confirm": "Bestätigen"
                    }
                }
            }
        }
    },
    "viewDetails": {
        "title": "Veröffentlichung ansehen",
        "form": {
            "label": {
                "required": "Erforderlich",
                "name": "Veröffentlichungsname",
                "version": "Veröffentlichungsversion",
                "subuser": "Unterbenutzer",
                "label": "Label",
                "copyright": "Copyright ©",
                "copyright_year": "Copyright © Jahr",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Copyright ℗ Jahr",
                "genre": "Genre",
                "subgenre": "Sub-Genre",
                "catalog_number": "Katalognummer",
                "artwork": "Artwork",
                "artwork_alt": "Ihr Artwork",
                "new_release": "Ist dies eine neue Veröffentlichung?",
                "original_release_date": "Ursprüngliches Veröffentlichungsdatum",
                "official_release_date": "Offizielles Veröffentlichungsdatum",
                "backcatalog": "Backkatalog",
                "assisted_dates": "Unterstützte Daten",
                "exclusive_store_release_date": "Exklusives Store-Veröffentlichungsdatum",
                "additional_metadata": "Zusätzliche Metadaten",
                "release_description": "Veröffentlichungsbeschreibung",
                "release_language": "Sprache des Veröffentlichungsnamens",
                "auto_detect_language": "Automatisch erkennen (Sprache)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Automatisch generieren (ean)",
                "territories": "Gebiete",
                "countries": "Länder",
                "youtube_declaration_header": "YOUTUBE CONTENT ID ERKLÄRUNG",
                "youtube_declaration_intro": "Um sich für YouTube Content ID für diese Veröffentlichung anzumelden, müssen Sie sicherstellen, dass Sie ALLE folgenden Anforderungen erfüllen:",
                "youtube_declaration_certify": "Ich, <strong>{{firstName}} {{lastName}}</strong>, erkläre unter Strafe des Meineids, dass die vorstehenden Informationen wahr und korrekt sind.",
                "youtube_declaration_point1": "Ich habe ausreichende Rechte an dem Material.",
                "youtube_declaration_point2": "Alle Referenzinhalte sind ausreichend unterscheidbar.",
                "youtube_declaration_point3": "Ich habe individuelle Referenzen für jedes Stück geistigen Eigentums.",
                "youtube_declaration_point4": "Gelieferte Inhalte sind <strong>nicht</strong> eines der folgenden: gemeinfreie, nicht exklusiv lizenzierte Inhalte, Clips aus anderen Quellen, die unter Fair-Use-Prinzipien verwendet werden, Videospielaufnahmen (außer vom Publisher des Spiels), Karaoke-Aufnahmen, Remaster ohne Erlaubnis, Sound-alike-Aufnahmen, synchronisierte Inhalte, Beschleunigung/Verlangsamung, Soundeffekte, Soundbeds, kontinuierliche DJ-Mixes, Mashups, Countdown-Listen oder andere verbotene oder nicht zulässige Inhalte, die in den unten aufgeführten YouTube Content ID-Richtlinien genannt werden.",
                "youtube_declaration_account": "Ich verstehe, dass mein Konto bei Verstößen deaktiviert und gekündigt werden kann. Darüber hinaus verstehe ich vollständig, dass ich für alle Gebühren, Schäden, Rechtskosten oder andere anfallende Kosten haftbar gemacht werden kann.",
                "youtube_declaration_guidelines": "Gemäß <1><strong>YouTubes Content ID-Richtlinien</strong></1> ist der durch diese Veröffentlichung eingereichte Inhalt vollständig für YouTube Content ID berechtigt.",
                "youtube_content_id_eligible": "Ich bestätige, dass mein Inhalt für <strong>YouTube Content ID</strong> berechtigt ist",
                "youtube_content_id_not_eligible": "Mein Inhalt ist nicht für <strong>YouTube Content ID</strong> berechtigt",
                "immersive_audio": "Diese Veröffentlichung hat Immersive Audio"
            },
            "placeholder": {
                "version": "Leer lassen, wenn Sie sich nicht sicher sind oder wenn dies eine reguläre Veröffentlichung ist",
                "select_date": "Datum auswählen...",
                "copyright": "Normalerweise Ihr Labelname",
                "copyright_publisher": "Normalerweise Ihr Labelname",
                "copyright_year": "JJJJ",
                "copyright_year_publisher": "JJJJ",
                "catalog_number": "Geben Sie Ihre Katalognummer ein. Normalerweise fügen Labels eine Abkürzung des Labelnamens und eine Nummer ein. Z.B. {{prefix}}001, {{prefix}}002...",
                "label": "Label auswählen...",
                "subuser": "Unterbenutzer auswählen...",
                "artist": "Künstler auswählen...",
                "genre": "Genre auswählen...",
                "subgenre": "Sub-Genre auswählen...",
                "ean": "Leer lassen, wenn Sie sich nicht sicher sind!",
                "release_description": "Ein paar Worte über Ihre Veröffentlichung. Bitte keine Links und E-Mail-Adressen. Maximal 600 Zeichen"
            },
            "help_text": {
                "name": "Bitte verwenden Sie keine Veröffentlichungsnamen-Zusätze wie LP und EP.",
                "version": "Einige Veröffentlichungen werden in mehr als einer Version veröffentlicht, wenn ja, geben Sie bitte den Versionsnamen ein. Wenn Ihre Veröffentlichung eine Original-/Standardveröffentlichung ist, ignorieren Sie dieses Feld bitte.",
                "subuser": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung für einen Ihrer Unterbenutzer hinzufügen möchten, andernfalls lassen Sie es unselektiert.",
                "catalog_number": "Geben Sie Ihre Katalognummer ein. Normalerweise fügen Labels eine Abkürzung des Labelnamens und eine Nummer ein. Z.B. {{prefix}}001, {{prefix}}002...",
                "artwork": "Laden Sie JPG-Formate hoch, Auflösung nur 3000x3000 px, @ 72 dpi",
                "original_release_date": "Ursprüngliches Veröffentlichungsdatum für alle Shops weltweit.",
                "official_release_date": "Offizielles Veröffentlichungsdatum für alle Shops weltweit.",
                "release_language": "In welcher Sprache ist der Veröffentlichungsname geschrieben? Bitte überprüfen Sie es doppelt, wenn Sie sich nicht sicher sind. Wenn diese Eingabe falsch ist, werden einige Stores wie iTunes und Apple Music die Veröffentlichung ablehnen.",
                "ean": "Der Universal Product Code oder die Europäische Artikelnummer für die Veröffentlichung. Gültige Codes sind 13-stellig. Wenn Sie keinen eigenen haben, werden wir einen für Sie generieren."
            },
            "option": {
                "yes": "Ja",
                "no": "Nein",
                "no_exclusive": "Keine Exklusivität",
                "beatport_2weeks": "Beatport 2 Wochen",
                "beatport_4weeks": "Beatport 4 Wochen",
                "preorder_1week": "Vorbestellung 1 Woche",
                "preorder_2weeks": "Vorbestellung 2 Wochen",
                "traxsource_2weeks": "Traxsource 2 Wochen",
                "select": "Auswählen...",
                "worldwide": "Weltweit",
                "only_selected": "Nur ausgewählte Länder",
                "all_except_selected": "Alle außer ausgewählte Länder"
            },
            "message": {
                "track_name_required": "Bitte geben Sie den Tracknamen ein",
                "mix_name_required": "Bitte geben Sie den Mixnamen ein",
                "mix_name_invalid": "Der Mixname darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen",
                "artist_required": "Bitte wählen Sie einen Künstler aus",
                "artist_type_required": "Bitte wählen Sie den Künstler-Typ aus",
                "catalog_duplicate": "Katalognummer '{{number}}' wurde verwendet. Bitte geben Sie eine andere ein.",
                "artist_added": "Neuer Künstler wurde hinzugefügt!",
                "track_limit": "Ihr aktuelles Track-Limit ist {{trackLimit}} Track(s). Um weitere Tracks hochzuladen, aktualisieren Sie bitte Ihr Konto oder kontaktieren Sie unser Support-Team.",
                "select_day": "Bitte wählen Sie einen Tag aus.",
                "form_error": "Formular kann nicht eingereicht werden! Bitte füllen Sie alle Felder aus und überprüfen Sie die Fehler!",
                "ean_invalid": "Der Wert ist keine gültige EAN. Wenn Sie eine neue Veröffentlichung einfügen, lassen Sie dieses Feld leer und wir generieren eine EAN für Sie. Wenn Sie einen Back-Katalog hochladen und die EAN ungültig ist, kontaktieren Sie uns bitte.",
                "ean_length": "Die EAN-Nummer muss 13 Zeichen lang sein",
                "artwork_invalid": "Diese Datei ist ungültig, bitte stellen Sie sicher, dass das Bild die .jpg-Erweiterung hat, RGB-Farben, 3000 x 3000 Abmessungen und bis zu 4 MB.",
                "track_invalid": "Diese Datei ist ungültig, bitte stellen Sie sicher, dass Ihre Datei ordnungsgemäß in 16 Bit, 44,1 kHz codiert ist."
            },
            "button": {
                "submit": "Formular einreichen"
            },
            "modal": {
                "assisted_days": {
                    "header": "Sind Sie sicher, dass Sie die besten Praktiken für das Veröffentlichungsdatum ignorieren möchten?",
                    "body": "Bitte beachten Sie, dass durch die Auswahl dieser Option Ihr Veröffentlichungsdatum möglicherweise nicht von den Stores akzeptiert oder am ausgewählten Datum aufgenommen und veröffentlicht wird. Darüber hinaus reduzieren Sie die Marketingmöglichkeiten erheblich.",
                    "button": {
                        "cancel": "Abbrechen",
                        "confirm": "Bestätigen"
                    }
                },
                "release_updated": {
                    "header": "Veröffentlichung aktualisiert!",
                    "body": "Ihre Veröffentlichung wurde erfolgreich aktualisiert!",
                    "button": {
                        "close": "Schließen"
                    }
                }
            }
        }
    },
    "artists_row": {
        "artistType": {
            "main": "Hauptkünstler",
            "featuring": "Mitwirkender Künstler",
            "remixer": "Remixer"
        },
        "placeholder": {
            "selectArtist": "Künstler auswählen..."
        },
        "button": {
            "remove": "Entfernen",
            "addAnother": "Weitere hinzufügen",
            "createNew": "Neu erstellen?"
        },
        "modal": {
            "header": "Sind Sie sicher, dass Sie diesen Künstler als Mitwirkenden Künstler zuweisen möchten?",
            "body": "Bitte verwechseln Sie den Mitwirkenden Künstler nicht mit einem Remixer. Ein Mitwirkender Künstler sollte nur hinzugefügt werden, wenn Sie sicher sind, dass dieser Künstler nicht der Hauptkünstler oder Remixer ist.",
            "cancel": "Abbrechen",
            "confirm": "Bestätigen"
        },
        "label": {
            "order": "Reihenfolge",
            "artistName": "Künstlername",
            "artistType": "Künstlertyp",
            "artists": "Künstler",
            "required": "Erforderlich"
        },
        "help_text": {
            "artists": "Wenn die Veröffentlichung von mehr als <strong>4 Hauptkünstlern</strong> geschrieben wurde, verwenden Sie bitte <strong>Verschiedene Künstler</strong>. Track-Künstler, Remixer und Mitwirkende sollten im Track-Bearbeitungsschritt hinzugefügt werden."
        }
    },
    "tracks_row": {
        "label": {
            "tracks": "Tracks",
            "order": "Reihenfolge",
            "trackName": "Trackname",
            "mixName": "Mixname",
            "file": "Datei",
            "albumOnly": "Nur Album",
            "required": "Erforderlich",
            "stereo": "Stereo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Weitere hinzufügen",
            "remove": "Entfernen?",
            "onlyAlbum": "Nur Album",
            "mixTypes": {
                "originalMix": "Original Mix",
                "remixOrMix": "Dies ist ein Remix oder Mix"
            }
        },
        "button": {
            "remove": "Entfernen",
            "addAnother": "Weitere hinzufügen"
        },
        "validation": {
            "trackName": "Bitte geben Sie den Tracknamen ein",
            "mixName": "Bitte geben Sie den Mixnamen ein",
            "mixNameRegex": "Der Mixname darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen",
            "trackFile": "Bitte wählen Sie die Trackdatei aus",
            "trackFileDolby": "Bitte wählen Sie die Dolby Atmos-Trackdatei aus",
            "trackFileDuration": "Die Dauer der Stereo- und Dolby-Trackdateien muss übereinstimmen",
            "swapTrackAudioTokenRequiredTooltip": "Ihr aktuelles Token-Guthaben ist unzureichend. Es ist mindestens 1 Token erforderlich, um die Track-Audio auszutauschen."
        }
    },
    "transfer_artists_row": {
        "label": {
            "artists": "Künstler",
            "order": "Reihenfolge",
            "artistName": "Künstlername",
            "artistType": "Künstlertyp",
            "required": "Erforderlich"
        },
        "placeholder": {
            "selectArtist": "Künstler auswählen..."
        },
        "help_text": {
            "artists": "Wenn die Veröffentlichung von mehr als <strong>4 Hauptkünstlern</strong> geschrieben wurde, verwenden Sie bitte <strong>Verschiedene Künstler</strong>. Track-Künstler, Remixer und Mitwirkende sollten im Track-Bearbeitungsschritt hinzugefügt werden."
        },
        "option": {
            "artistType": {
                "main": "Hauptkünstler",
                "featuring": "Mitwirkender Künstler",
                "remixer": "Remixer"
            }
        },
        "button": {
            "remove": "Entfernen",
            "addAnother": "Weitere hinzufügen",
            "createNew": "Neu erstellen?"
        },
        "message": {
            "errorArtistRequired": "Bitte wählen Sie einen Künstler aus",
            "errorArtistTypeRequired": "Bitte wählen Sie den Künstlertyp aus"
        },
        "modal": {
            "header": "Sind Sie sicher, dass Sie diesen Künstler als Mitwirkenden Künstler zuweisen möchten?",
            "body": "Bitte verwechseln Sie den Mitwirkenden Künstler nicht mit einem Remixer. Ein Mitwirkender Künstler sollte nur hinzugefügt werden, wenn Sie sicher sind, dass dieser Künstler nicht der Hauptkünstler oder Remixer ist.",
            "button": {
                "cancel": "Abbrechen",
                "confirm": "Bestätigen"
            }
        }
    },
    "store_picker": {
        "label": {
            "stores": "Shops"
        },
        "placeholder": {
            "search": "Shop suchen..."
        },
        "section": {
            "mandatory": "Pflicht",
            "optional": "Optional",
            "optional_locked": "Optional Zusätzliche Stores",
            "summary": {
                "read_only": "{{title}} ({{count}} gesamt)",
                "editable": "{{title}} ({{total}} gesamt, {{selected}} ausgewählt)"
            }
        },
        "message": {
            "no_stores": "Keine Shops gefunden.",
            "availability": "Beatport ist nur für Dance-Releases mit Beatport-freigegebenen Labels verfügbar. Traxsource ist nur für Dance-Releases mit Traxsource-freigegebenen Labels verfügbar.",
            "youtube_declaration": "Bitte unterschreiben Sie zuerst die YouTube Content ID-Erklärung.",
            "youtube_ineligible": "Dieser Shop ist nicht verfügbar, da Sie angegeben haben, dass Sie nicht über die Eigentumsrechte verfügen. Bei falscher Angabe könnten Sie für einen Rechtsstreit haftbar gemacht werden.",
            "youtube_content_id": "Dieser Shop ist für YouTube Content ID-berechtigte Releases nicht anwendbar, da er sowohl an YouTube Content ID als auch an YouTube Premium geliefert wird.",
            "beatport": "Beatport kann nur ausgewählt werden, wenn das Genre Dance ist und das Label für Beatport freigegeben ist.",
            "traxsource": "Traxsource kann nur ausgewählt werden, wenn das Genre Dance ist und das Label für Traxsource freigegeben ist.",
            "juno": "JunoDownload kann nur ausgewählt werden, wenn das Genre Dance ist.",
            "contact_support": "Bitte kontaktieren Sie unser Support-Team, um diese Shops freizuschalten.",
            "optional_additional_none_selected": "Sie haben keine optionalen zusätzlichen Stores ausgewählt. Diese können Ihre Reichweite erhöhen. Sind Sie sicher, dass Sie sie überspringen möchten?",
            "optional_paid_insufficient_tokens": "Unzureichendes Token-Guthaben. Es ist mindestens 1 Token erforderlich, um optionale zusätzliche Stores auszuwählen.",
            "optional_paid_insufficient_tokens_with_link": "Ihr aktuelles Token-Guthaben ist unzureichend. Es ist mindestens 1 Token erforderlich, um optionale zusätzliche Stores auszuwählen. <2>Tokens bestellen</2>, um fortzufahren."
        }
    },
    "transfer_tracks_row": {
        "label": {
            "tracks": "Tracks",
            "order": "Reihenfolge",
            "trackName": "Trackname",
            "mixName": "Mixname",
            "file": "Datei",
            "albumOnly": "Nur Album",
            "required": "Erforderlich",
            "stereo": "Stereo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Weitere hinzufügen",
            "remove": "Entfernen?",
            "onlyAlbum": "Nur Album",
            "mixTypes": {
                "originalMix": "Original Mix",
                "remixOrMix": "Dies ist ein Remix oder Mix"
            }
        },
        "button": {
            "remove": "Entfernen",
            "addAnother": "Weitere hinzufügen"
        },
        "validation": {
            "trackName": "Bitte geben Sie den Tracknamen ein",
            "mixName": "Bitte geben Sie den Mixnamen ein",
            "mixNameRegex": "Der Mixname darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen",
            "trackFile": "Bitte wählen Sie die Trackdatei aus",
            "trackFileDolby": "Bitte wählen Sie die Dolby Atmos-Trackdatei aus",
            "trackFileDuration": "Die Dauer der Stereo- und Dolby-Trackdateien muss übereinstimmen"
        }
    }
};

export default releasesDE;